import * as React from 'react';
import { useLocation } from 'react-router-dom';

/** Remonte en haut à chaque navigation. */
export default function ScrollToTop({ behavior = 'auto' }) {
  const { pathname, search } = useLocation();

  React.useEffect(() => {
    // Toujours en haut (et à gauche) après navigation
    window.scrollTo({ top: 0, left: 0, behavior });
  }, [pathname, search, behavior]);

  return null;
}